module.exports = __webpack_public_path__ + "static/media/racerun.8c54cf39.svg";